export type StateChoice = {
    id: number;
    name: string;
    state_code: string;
};

/** Normalize DB value (state id, code, or legacy name) to state_code for SelectInput. */
export const resolveStateCode = (
    value: string | number | null | undefined,
    stateChoices: StateChoice[]
): string | number | null | undefined => {
    if (value == null || value === '') return value;

    const raw = String(value).trim();
    const byCode = stateChoices.find(
        (state) => state.state_code.toUpperCase() === raw.toUpperCase()
    );
    if (byCode) return byCode.state_code;

    const byId = stateChoices.find((state) => String(state.id) === raw);
    if (byId) return byId.state_code;

    const lower = raw.toLowerCase();
    const byName = stateChoices.find(
        (state) => state.name.toLowerCase() === lower
    );
    if (byName) return byName.state_code;

    return value;
};

export const mapStatesToChoices = (
    states: { id: number; state_name?: string; name?: string; state_code?: string }[]
): StateChoice[] =>
    (states || [])
        .map((state) => ({
            id: state.id,
            name: state.state_name || state.name || '',
            state_code: state.state_code || '',
        }))
        .filter((state) => Boolean(state.name) && Boolean(state.state_code));
